module.exports = __webpack_public_path__ + "img/empty@3x.037feeb8.png";